import React from "react"
import { useTranslate } from "hooks/translate"
import Heading from "app/components/Heading"
import Copyright from "app/components/Copyright"
import { StyledLink } from "../Default/style"
import {
  StyledContainer,
  StyledLayout,
  StyledLayoutAside,
  StyledLayoutAsideBody,
  StyledLayoutMain,
  StyledLayoutSection,
  StyledFooter,
  StyledDivider,
  StyledFooterContent,
  StyledHeader,
  StyledLogoWrapper,
  StyledLogo,
} from "./style"

const LayoutPreOwned: React.FC = ({ children }) => {
  const { t } = useTranslate()

  return (
    <>
      <StyledHeader>
        <StyledLogoWrapper>
          <StyledLink to="/">
            <StyledLogo />
          </StyledLink>
        </StyledLogoWrapper>
      </StyledHeader>
      <StyledLayout>
        <StyledLayoutAside>
          <StyledLayoutAsideBody>
            <div>
              <Heading>{t("form.aside.preowned.heading")}</Heading>
              <p>
                {t("form.aside.preowned.description", {
                  br: <br />
                })}
              </p>
            </div>
          </StyledLayoutAsideBody>
        </StyledLayoutAside>
        <StyledLayoutMain>
          <StyledLayoutSection>
            <StyledContainer>{children}</StyledContainer>
          </StyledLayoutSection>
        </StyledLayoutMain>
      </StyledLayout>
      <StyledFooter>
        <StyledDivider />
        <StyledFooterContent>
          <div>
            <Copyright>
              {t("system.legal.copyright", { year: new Date().getFullYear() })}
            </Copyright>
          </div>
        </StyledFooterContent>
      </StyledFooter>
    </>
  )
}

export default LayoutPreOwned
